import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  TELECOM_DOMAIN_INTRO,
  TELECOM_GROUPS,
  TELECOM_USE_CASES_SEO,
  TELECOM_DOMAIN_FAQS,
  TELECOM_ITEM_LIST_JSONLD,
  TELECOM_BREADCRUMB_JSONLD,
  TELECOM_WEBPAGE_JSONLD,
  TELECOM_FAQ_JSONLD,
} from "../../data/rpa/telecom-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = TELECOM_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function TelecomRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? TELECOM_GROUPS
      : TELECOM_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={TELECOM_DOMAIN_INTRO}
        domainSlug="telecom-domain"
        basePath="/rpa-use-cases"
        useCaseCount={TELECOM_USE_CASES_SEO.length}
        groupCount={TELECOM_GROUPS.length}
        itemListJsonLd={TELECOM_ITEM_LIST_JSONLD}
        faqJsonLd={TELECOM_FAQ_JSONLD}
        breadcrumbJsonLd={TELECOM_BREADCRUMB_JSONLD}
        webPageJsonLd={TELECOM_WEBPAGE_JSONLD}
        keywords="Telecom automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{TELECOM_DOMAIN_INTRO.title}</h1>
          {TELECOM_DOMAIN_INTRO.content ? <p>{TELECOM_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={TELECOM_USE_CASES_SEO}
        groups={TELECOM_GROUPS}
        heading="Telecom Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={TELECOM_DOMAIN_INTRO.title}
        domainFaqs={TELECOM_DOMAIN_FAQS}
        useCases={TELECOM_USE_CASES_SEO}
      />
    </div>
  );
}

